import axios from 'axios';

import { RESTSERVICES_BASE_URL } from './constants';

const CONTACT_URL = `${RESTSERVICES_BASE_URL}/contact`;
export const getContact = () =>
  axios
    .get<Record<string, any>>(CONTACT_URL, { params: { useCrmApi: true } })
    .then((res) => res.data);

export const updateContact = ({ values = {} }) => axios.patch(CONTACT_URL, { ...values });
